import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LANGS } from "../i18n";

const SITE = "https://chef-adomicile.com";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href, hreflang) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, jsonLd, image }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description || "");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Chef à Domicile");
    setMeta("property", "og:url", SITE + pathname);
    if (image) setMeta("property", "og:image", image);
    setLink("canonical", SITE + pathname);
    const rest = pathname.replace(/^\/(fr|en|ar|es|it|de|zh)/, "");
    LANGS.forEach((l) => setLink("alternate", `${SITE}/${l.code}${rest}`, l.code));
    setLink("alternate", `${SITE}/fr${rest}`, "x-default");

    let script = document.getElementById("jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) script.remove();
  }, [title, description, jsonLd, image, pathname]);
  return null;
}
